import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'SelectScenes_Msg',
      'TOOL',
      'StyleMsg',
      'SpriteOperation',
      'SelectSprites_Msg',
      'UserEquity',
      'UserLevel',
      'UserLevelName',
      'UserLevelType',
      'IsVipSprites',
      'PersonVideoNumber',
    ]),
    limit () {
      return this.UserEquity.draftVideo;
    }
  },
  methods: {
    getSprites () {
      const vm = this;
      let list = (vm.TOOL.sprites || []).reduce((memo, v, i) => {
        return memo.concat(v.sprites);
      }, []);
      return list.filter((item) => {
        return item.option.fileType === 26 || item.option.fileType === 27;
      }) || [];
    },
    getBackgrounds () {
      return (this.TOOL.sprites || []).filter((item) => {
        let bgData = item.background.data;
        let type = bgData.type;
        let fileType = bgData.fileType;
        return type === 'Video' && fileType !== 25;
      }) || [];
    },

    getNumber () {
      return this.getSprites().length + this.getBackgrounds().length;
    },

    getVideoArr () {
      return [...this.getSprites(), ...this.getBackgrounds()];
    },

    isPersonVideosExcess () {
      if (this.limit === Infinity) {
        return false;
      }

      let count = this.getNumber();
      return count > this.limit;
    },

    isPersonVideosEqual () {
      if (this.limit === Infinity) {
        return false;
      }

      let count = this.getNumber();
      return count >= this.limit;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/checkPersonVideo.js